import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";

export const studentImportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // For importing students
    importStudents: builder.mutation<
      ApiResponseType<{
        success: boolean;
        imported: number;
        failed: number;
        errors?: any[];
      }>,
      { file: File }
    >({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: "students/import-students",
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["Students"],
    }),

    // For downloading the template
    downloadStudentImportTemplate: builder.query<Blob, number | void>({
      query: (t) => ({
        url: `students/download-template-student-import?t=${t || Date.now()}`,
        method: "GET",
        responseHandler: async (response) => await response.blob(),
      }),
    }),
  }),
});

export const {
  useImportStudentsMutation,
  useDownloadStudentImportTemplateQuery,
  useLazyDownloadStudentImportTemplateQuery,
} = studentImportApi;
